module.exports = __webpack_public_path__ + "static/media/app design (2).12d21817.png";